import React from 'react';
import App from '../components/App'

export default function AppPage({setErrorMessage, loggedInAccount }) {
    return <App setErrorMessage={setErrorMessage} loggedInAccount={loggedInAccount} />;
}